var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-body"},[_c('el-row',[_c('el-col',{staticClass:"align-right",attrs:{"span":24}},[_c('el-button',{staticClass:"btn btn-success btn-sm",attrs:{"type":"success"}},[_vm._v(" Add New ")])],1)],1)],1),_c('table-responsive',{attrs:{"data":_vm.currenciesData}}),_c('the-footer',{attrs:{"divide":2,"first-button":{
      isPlain: true,
      class: 'align-left',
      classList: 'btn-icon btn-white',
      trigger: {
        function: 'moveTo',
        argument: -1
      },
      text: 'Previous'
    },"second-button":{
      isPlain: true,
      class: 'align-right',
      classList: 'btn-icon btn-white',
      trigger: {
        function: 'moveTo',
        argument: 1
      },
      text: 'Next'
    }},on:{"moveTo":function($event){return _vm.moveTo($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }